import type CartTimerHandler from '../utilityNav/CartTimerHandler';

let cartTimerHandler: CartTimerHandler;

export default {
  setCartTimerHandler: (value: CartTimerHandler) => {
    cartTimerHandler = value;
  },
  getCartTimerHandler: () => cartTimerHandler,
};
